















import { defineComponent, computed } from '@vue/composition-api';

import CollectFile from '@/renderer/views/common/collect/components/CollectFile.vue';

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
    isSubmit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CollectFile,
  },
  setup(props, ctx) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        ctx.emit('update:show', val);
      },
    });
    return {
      innerShow,
    };
  },
});
